<template>
  <div class="app-main-content pay-management">
    <div class="grid-view">
      <div class="main-content">
        <div class="section">
          <el-form :inline="true" label-width="100px" label-position="left" @submit.native.prevent>
            <el-form-item :label="$t('CargoMsg.Cargo_CollectFeeType')">
              <!--收费类型-->
              <el-select
                v-model="searchConditions.itemType"
                no="itemType"
                :placeholder="$t('common.tips.pleaseChoose')"
                style="width: 100%"
              >
                <el-option
                  v-for="item in itemTypeArray"
                  :key="item.code"
                  :label="item.desc"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('Information.ChargeGroup')">
              <cargo-advance-select
                no="chargeGroupUuid"
                filterable
                :select-type="selectTypeNames.basic_data_ChargeGroup"
                tag-name="name"
                tag-value="uuid"
                style="width: 286px;"
                @parentCallBack="p=>{searchConditions.chargeGroupUuid=p.uuid}"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <el-input
                v-model="searchConditions.name"
                no="name"
                style="width: 286px;"
                :placeholder="$t('Message.PleaseEnterTheNameOfTheCosts')"
                @change="searchConditions.pageNum=1"
                @keyup.enter.native="fetchPayServiceList"
              />
            </el-form-item>
            <el-form-item label-width="0">
              <el-button no="fetchPayServiceList" type="primary" @click="fetchPayServiceList">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="$checkPermission(['write_SMChargeItem'])" class="section">
          <el-form :inline="true" label-width="0">
            <el-form-item label-width="0" class="auto-width">
              <el-button no="popPayServiceAdd" type="primary" @click="popPayServiceAddFormDialog">{{ $t('CargoMsg.Cargo_NewTo') }}</el-button>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <el-button no="popPayServiceEdit" type="primary" @click="popPayServiceEditFormDialog">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <el-button no="toBatchDel" type="danger" @click="toBatchDel">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <el-button no="batchSettingDefault" type="primary" @click="batchSettingDefault">{{ $t('CargoMsg.Cargo_SetUpDefaultsInBatch') }}</el-button>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <el-button no="batchCancelDefault" type="primary" @click="batchCancelDefault">{{ $t('CargoMsg.Cargo_CancelDefaultsInBatch') }}</el-button>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <el-button no="popSettingServiceType" type="primary" @click="popSettingServiceTypeDialog">{{ $t('CargoMsg.Cargo_SetUpServiceTypesInBatch') }}</el-button>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <el-button no="combineChargeItem" type="primary" @click="combineChargeItem">{{ $t('CargoMsg.Cargo_Combine') }}</el-button>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <el-button no="enable" type="primary" @click="enableOrNot(true)">{{ $t('CargoMsg.Cargo_Enable') }}</el-button>
            </el-form-item>

            <el-form-item label-width="0" class="auto-width">
              <el-button no="disable" type="danger" @click="enableOrNot(false)">{{ $t('CargoMsg.Cargo_Disable') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            no="100601-grid"
            config-module="100601"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="searchConditions.total>0"
            no="100601-pagination"
            config-module="1006011"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchPayServiceList"
          />
        </div>
      </div>
    </div>
    <!-- 费用项目维护 -->
    <el-dialog
      v-if="showChargeItemMaintain"
      slot="reference"
      v-el-drag-dialog
      no="chargeItemManagementMaintain"
      :close-on-click-modal="false"
      class="charge-item-maintain-dialog"
      :visible.sync="showChargeItemMaintain"
      :title="chargeItemManagementMaintainTitle"
      inline-message
      :width="isZh ? '500px' : '550px'"
    >
      <div v-if="showChargeItemMaintain">
        <el-scrollbar style="height:450px;">
          <el-form
            ref="chargeItemManagementForm"
            :model="chargeItemManagementForm"
            :label-width="isZh ? '160px' : '210px'"
            label-position="left"
            style="padding-right: 10px"
          >
            <el-form-item :label="$t('CargoMsg.Cargo_Index')">
              <el-input v-model="chargeItemManagementForm.itemId" no="itemId" disabled />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DisplayOrder')">
              <el-input-number
                v-model="chargeItemManagementForm.serialNumber"
                no="serialNumber"
                :min="0"
                :max="999"
                controls-position="right"
                :disabled="isView"
                @change="serialNumberCharge"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_abbreviation')">
              <el-input v-model="chargeItemManagementForm.chargecode" no="chargecode" :maxlength="8" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PlatformCode2')">
              <el-input v-model="chargeItemManagementForm.scaleCode" no="scaleCode" :maxlength="10" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('Information.ChargeGroup')">
              <cargo-advance-select
                no="chargeGroupUuid2"
                filterable
                :disabled="isView"
                :select-type="selectTypeNames.basic_data_ChargeGroup"
                :default-value="chargeItemManagementForm.chargeGroupUuid || ''"
                tag-name="name"
                tag-value="uuid"
                @parentCallBack="p=>{chargeItemManagementForm.chargeGroupUuid=p.uuid}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_InterchaneeCode')">
              <el-input v-model="chargeItemManagementForm.interchangeCode" no="interchangeCode" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ChineseName')">
              <el-input v-model="chargeItemManagementForm.zhName" no="zhName" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EnglishName')">
              <!--              <el-input no="enName" v-model="chargeItemManagementForm.enName" :disabled="isView"/>-->
              <charge-language-dialog
                v-model="chargeItemManagementForm.enName"
                no="enName"
                :disabled="isView"
                style="margin-bottom: 10px;"
                :items="chargeItemManagementForm.chargeLanguageValues"
                @childChargeLanguage="chargeLanguageValues"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Metrics')">
              <!--衡量标准-->
              <el-select
                v-model="chargeItemManagementForm.measure"
                no="measure"
                :placeholder="$t('common.tips.pleaseChoose')"
                style="width: 100%"
                :disabled="isView"
              >
                <el-option
                  v-for="item in measureArray"
                  :key="item.code"
                  :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ServiceItems')">
              <!--服务项目-->
              <!--              <el-select
                v-model="chargeItemManagementForm.serviceType"
                clearable
                style="width: 100%"
                :disabled="isView"
              >
                <el-option
                  v-for="item in serviceTypeArray"
                  :key="item.code"
                  :label="item.desc"
                  :value="item.code"
                />
              </el-select>-->
              <el-cascader
                v-model="chargeItemManagementForm.serviceType"
                no="serviceType"
                style="width: 100%;"
                :options="serviceTypeArray"
                :props="{ checkStrictly: true }"
                clearable
                :disabled="isView"
                @change="changeServiceType"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_AutoGenerateFeeName')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_ChargeItem"
                :default-value="chargeItemManagementForm.autoGenerateChargeId"
                :disabled="isView"
                tag-value="itemId"
                tag-name="zhName"
                clearable
                @parentCallBack="p=>chargeItemManagementForm.autoGenerateChargeId=p.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_AutoGenerateTaxRate')">
              <el-input-number v-model="chargeItemManagementForm.autoGenerateChargeTaxRate" :disabled="isView" :controls="false" :precision="2" :min="0" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ForSeaExportBusiness')">
              <el-checkbox v-model="chargeItemManagementForm.seaExport" no="seaExport" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ForSeaImportBusiness')">
              <el-checkbox v-model="chargeItemManagementForm.seaImport" no="seaImport" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ForAirExportBusiness')">
              <el-checkbox v-model="chargeItemManagementForm.airExport" no="airExport" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ForAirImportBusiness')">
              <el-checkbox v-model="chargeItemManagementForm.airImport" no="airImport" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ForRailwayBusiness')">
              <el-checkbox v-model="chargeItemManagementForm.railwayExport" no="railwayExport" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ForIntegratedJob')">
              <el-checkbox v-model="chargeItemManagementForm.integratedJob" no="integratedJob" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ForFbaSeaBusiness')">
              <el-checkbox v-model="chargeItemManagementForm.fbaSea" no="fbaSea" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ForFbaAirBusiness')">
              <el-checkbox v-model="chargeItemManagementForm.fbaAir" no="fbaAir" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ForFbaRailwayBusiness')">
              <el-checkbox v-model="chargeItemManagementForm.fbaRailway" no="fbaRailway" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('Payment.controlledOrNot')">
              <el-checkbox v-model="chargeItemManagementForm.controlled" no="controlled" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_NeedInvoiceOrNot')">
              <el-checkbox v-model="chargeItemManagementForm.needInvoice" no="needInvoice" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CommissionOrNot')">
              <el-checkbox v-model="chargeItemManagementForm.commission" no="commission" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_AdvanceOrNot')">
              <el-checkbox v-model="chargeItemManagementForm.advance" no="advance" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_SurchargeOrNot')">
              <el-checkbox v-model="chargeItemManagementForm.surcharge" no="surcharge" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_LocalChargeOrNot')">
              <el-checkbox v-model="chargeItemManagementForm.localCharge" no="localCharge" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DestinationChargeOrNot')">
              <el-checkbox v-model="chargeItemManagementForm.desCharge" no="desCharge" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_IsItDefaultExpense')">
              <el-checkbox v-model="chargeItemManagementForm.defaultChargeItem" no="defaultChargeItem" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_IsCharterFlightCosts')">
              <el-checkbox v-model="chargeItemManagementForm.charterFlight" no="charterFlight" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_IsCharterVesselCosts')">
              <el-checkbox v-model="chargeItemManagementForm.charterVessel" no="charterVessel" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_OtherBusinessUse')">
              <el-checkbox v-model="chargeItemManagementForm.forothers" no="forothers" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ZeroTaxRate')">
              <el-checkbox v-model="chargeItemManagementForm.zeroTaxRate" no="zeroTaxRate" :disabled="isView" @change="changeZeroTaxRate" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DefaultTaxRete')">
              <el-input-number v-model="chargeItemManagementForm.taxRate" no="taxRate" :disabled="isView || chargeItemManagementForm.zeroTaxRate" :controls="false" :precision="2" :min="0" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TaxRateRange')">
              <cargo-advance-select
                no="taxRateRage"
                :select-type="selectTypeNames.local_cache_TaxRateRanges"
                :callback-params="{key:'rateRange'}"
                callback-method-type="value"
                filterable
                :clearable="true"
                :multiple="true"
                :default-multiple-value="chargeItemManagementForm.rateRangeArr"
                :disabled="isView"
                @parentCallBack="p => {chargeItemManagementForm.rateRange = p.value.join(',')}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DefaultArSettlementObject')">
              <cargo-advance-select
                no="defaultArAccountId"
                :select-type="selectTypeNames.basic_data_Company"
                :callback-params="{key:'defaultArAccountId'}"
                callback-method-type="value"
                :default-value="chargeItemManagementForm.defaultArAccountId"
                filterable
                :disabled="isView"
                @parentCallBack="selectCargoItem"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DefaultPayer')">
              <!--默认应收对象-->
              <el-select
                v-model="chargeItemManagementForm.defaultArCode"
                no="defaultArCode"
                :placeholder="$t('common.tips.pleaseChoose')"
                :clearable="false"
                style="width: 100%"
                :disabled="isView"
                @change="defaultArCodeChange"
              >
                <el-option
                  v-for="item in defaultObjArray"
                  :key="item.code"
                  :label="item.desc"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DefaultArSettlementObjectNull')">
              <el-checkbox v-model="chargeItemManagementForm.useDefaultArCode" no="useDefaultArCode" :disabled="isView || (!isView && chargeItemManagementForm.defaultArCode === 'QXZ')" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DefaultARCurrency')">
              <!--默认应收币种-->
              <cargo-advance-select
                no="defaultarcurrency"
                :select-type="selectTypeNames.basic_data_Currency"
                :callback-params="{key:'defaultarcurrency'}"
                callback-method-type="value"
                :default-value="chargeItemManagementForm.defaultarcurrency"
                filterable
                style="width:205px;"
                :disabled="isView"
                @parentCallBack="selectCargoItem"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DefaultReceivableMode')">
              <el-radio-group v-model="chargeItemManagementForm.defaultArMode" no="defaultArMode">
                <el-radio :disabled="isView" :label="false" :value="false">{{ $t('CargoMsg.Cargo_DefaultUnitPrice') }}</el-radio>
                <el-radio :disabled="isView" :label="true" :value="true">{{ $t('CargoMsg.Cargo_DefaultRate') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="chargeItemManagementForm.defaultArMode == 0" :label="$t('CargoMsg.Cargo_DefaultARUnitPrice')">
              <el-input
                v-model="chargeItemManagementForm.defaultarprice"
                no="defaultarprice"
                oninput="value=value.replace(/[^0-9.]/g,'')"

                :disabled="isView"
              />
            </el-form-item>
            <div v-if="chargeItemManagementForm.defaultArMode == 1">
              <el-form-item :label="$t('CargoMsg.Cargo_DefaultReceivableRate')">
                <div style="display: flex;">
                  <el-checkbox v-model="chargeItemManagementForm.suitArRate" no="suitArRate" :disabled="isView" @change="formatChargeRate" />
                  <span style="padding-left: 5px;">{{ $t('CargoMsg.Cargo_Suit') }}</span>
                  <el-input-number v-model="chargeItemManagementForm.defaultArRate" no="defaultArRate" :controls="false" :precision="6" style="padding-left: 5px;width:250px;" :disabled="!chargeItemManagementForm.suitArRate || isView" />%
                </div>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SecondReceivableRate')">
                <div style="display: flex;">
                  <el-checkbox v-model="chargeItemManagementForm.suitSecondArRate" no="suitSecondArRate" :disabled="isView" @change="formatChargeRate" />
                  <span style="padding-left: 5px;">{{ $t('CargoMsg.Cargo_Suit') }}</span>
                  <el-input-number v-model="chargeItemManagementForm.secondArRate" no="secondArRate" :controls="false" :precision="6" style="padding-left: 5px;width:250px;" :disabled="!chargeItemManagementForm.suitSecondArRate || isView" />%
                </div>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_ChargeableAmountInterval')">
                <div style="display: flex;">
                  <el-checkbox v-model="chargeItemManagementForm.suitArAmountInterval" no="suitArAmountInterval" :disabled="isView" @change="formatChargeRate" />
                  <span style="padding-left: 5px;">{{ $t('CargoMsg.Cargo_Suit') }}</span>
                  <el-input-number v-model="chargeItemManagementForm.arAmountIntervalMin" no="arAmountIntervalMin" :controls="false" :precision="2" style="padding-left: 5px;width:131px;" :disabled="!chargeItemManagementForm.suitArAmountInterval || isView" />
                  -
                  <el-input-number v-model="chargeItemManagementForm.arAmountIntervalMax" no="arAmountIntervalMax" :controls="false" :precision="2" style="width:131px;" :disabled="!chargeItemManagementForm.suitArAmountInterval || isView" />
                </div>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_ReceivableIntervalType')">
                <el-select
                  v-model="chargeItemManagementForm.arIntervalType"
                  no="arIntervalType"
                  :placeholder="$t('common.tips.pleaseChoose')"
                  :clearable="false"
                  style="width: 100%"
                  :disabled="isView"
                >
                  <el-option
                    v-for="item in intervalTypeArray"
                    :key="item.code"
                    :label="item.desc"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </div>
            <el-form-item :label="$t('CargoMsg.Cargo_DefaultApSettlementObject')">
              <cargo-advance-select
                no="defaultApAccountId"
                :select-type="selectTypeNames.basic_data_Company"
                :callback-params="{key:'defaultApAccountId'}"
                callback-method-type="value"
                :default-value="chargeItemManagementForm.defaultApAccountId"
                filterable
                :disabled="isView"
                @parentCallBack="selectCargoItem"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DefaultPayee')">
              <!--默认应付对象-->
              <el-select
                v-model="chargeItemManagementForm.defaultApCode"
                no="defaultApCode"
                :placeholder="$t('common.tips.pleaseChoose')"
                :clearable="false"
                style="width: 100%"
                :disabled="isView"
                @change="defaultApCodeChange"
              >
                <el-option
                  v-for="item in defaultObjArray"
                  :key="item.code"
                  :label="item.desc"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DefaultApSettlementObjectNull')">
              <el-checkbox v-model="chargeItemManagementForm.useDefaultApCode" no="useDefaultApCode" :disabled="isView || (!isView && chargeItemManagementForm.defaultApCode === 'QXZ')" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DefaultAPCurrency')">
              <!--默认应付币种-->
              <cargo-advance-select
                no="defaultapcurrency"
                :select-type="selectTypeNames.basic_data_Currency"
                :callback-params="{key:'defaultapcurrency'}"
                callback-method-type="value"
                :default-value="chargeItemManagementForm.defaultapcurrency"
                filterable
                style="width:205px;"
                :disabled="isView"
                @parentCallBack="selectCargoItem"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DefaultPayableMode')">
              <el-radio-group v-model="chargeItemManagementForm.defaultApMode" no="defaultApMode">
                <el-radio :disabled="isView" :label="false" :value="false">{{ $t('CargoMsg.Cargo_DefaultUnitPrice') }}</el-radio>
                <el-radio :disabled="isView" :label="true" :value="true">{{ $t('CargoMsg.Cargo_DefaultRate') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="!chargeItemManagementForm.defaultApMode" :label="$t('CargoMsg.Cargo_DefaultAPUnitPrice')">
              <el-input
                v-model="chargeItemManagementForm.defaultapprice"
                no="defaultapprice"
                oninput="value=value.replace(/[^0-9.]/g,'')"

                :disabled="isView"
              />
            </el-form-item>
            <div v-if="chargeItemManagementForm.defaultApMode">
              <el-form-item :label="$t('CargoMsg.Cargo_DefaultPayableRate')">
                <div style="display: flex;">
                  <el-checkbox v-model="chargeItemManagementForm.suitApRate" no="suitApRate" :disabled="isView" @change="formatChargeRate" />
                  <span style="padding-left: 5px;">{{ $t('CargoMsg.Cargo_Suit') }}</span>
                  <el-input-number v-model="chargeItemManagementForm.defaultApRate" no="defaultApRate" :controls="false" :precision="6" style="padding-left: 5px;width:250px;" :disabled="!chargeItemManagementForm.suitApRate || isView" />%
                </div>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SecondRatePayable')">
                <div style="display: flex;">
                  <el-checkbox v-model="chargeItemManagementForm.suitSecondApRate" no="suitSecondApRate" :disabled="isView" @change="formatChargeRate" />
                  <span style="padding-left: 5px;">{{ $t('CargoMsg.Cargo_Suit') }}</span>
                  <el-input-number v-model="chargeItemManagementForm.secondApRate" no="secondApRate" :controls="false" :precision="6" style="padding-left: 5px;width:250px;" :disabled="!chargeItemManagementForm.suitSecondApRate || isView" />%
                </div>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_PayableAmountInterval')">
                <div style="display: flex;">
                  <el-checkbox v-model="chargeItemManagementForm.suitApAmountInterval" no="suitApAmountInterval" :disabled="isView" @change="formatChargeRate" />
                  <span style="padding-left: 5px;">{{ $t('CargoMsg.Cargo_Suit') }}</span>
                  <el-input-number v-model="chargeItemManagementForm.apAmountIntervalMin" no="apAmountIntervalMin" :controls="false" :precision="2" style="padding-left: 5px;width:131px;" :disabled="!chargeItemManagementForm.suitApAmountInterval || isView" />
                  -
                  <el-input-number v-model="chargeItemManagementForm.apAmountIntervalMax" no="apAmountIntervalMax" :controls="false" :precision="2" style="width:131px;" :disabled="!chargeItemManagementForm.suitApAmountInterval || isView" />
                </div>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_PayableIntervalType')">
                <el-select
                  v-model="chargeItemManagementForm.apIntervalType"
                  no="apIntervalType"
                  :placeholder="$t('common.tips.pleaseChoose')"
                  :clearable="false"
                  style="width: 100%"
                  :disabled="isView"
                >
                  <el-option
                    v-for="item in intervalTypeArray"
                    :key="item.code"
                    :label="item.desc"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </div>
            <el-form-item :label="$t('CargoMsg.Cargo_RemarksOnAROrAPItems')">
              <el-input v-model="chargeItemManagementForm.remark" no="remark" type="text" :disabled="isView" />
            </el-form-item>
            <el-form-item :label="$t('Information.DefaultWhtRate')">
              <el-input
                v-stopNumberMousewheel
                no="defaultWhtRate"
                :value="toFixedIfNumber(chargeItemManagementForm.defaultWhtRate,2)"
                :disabled="isView"
                @input="onDefaultWhtRateInput"
                @change="onDefaultWhtRateChange"
              />
            </el-form-item>
            <!--不参与AR/AP对应校验-->
            <el-form-item>
              <template slot="label">
                <span>{{ $t('Information.UncheckArApMate') }}
                  <el-tooltip
                    class="item"
                    :content="$t('Information.UncheckArApMateTip')"
                    placement="top"
                    effect="light"
                    style="color: #4AA4EA"
                  >
                    <i
                      class="el-icon-question"
                      style="font-size: 16px; vertical-align: middle;"
                    />
                  </el-tooltip>
                </span>
              </template>
              <el-checkbox v-model="chargeItemManagementForm.uncheckArApMate" no="uncheckArApMate" :disabled="isView" />
            </el-form-item>
            <!-- 合并展示至指定费用 -->
            <el-form-item v-if="isMergeChargeItemSalesView">
              <template slot="label">
                <span>{{ $t('Information.MergeAndDisplayToDesignatedFees') }}
                  <el-tooltip
                    class="item"
                    :content="$t('Information.MergeAndDisplayToDesignatedFeesTips')"
                    placement="top"
                    effect="light"
                    style="color: #4AA4EA"
                  >
                    <i
                      class="el-icon-question"
                      style="font-size: 16px; vertical-align: middle;"
                    />
                  </el-tooltip>
                </span>
              </template>
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_ChargeItem"
                :default-value="Number(chargeItemManagementForm.targetItemId) || ''"
                callback-method-type="value"
                style="width: 100%;"
                tag-name="zhName"
                tag-value="itemId"
                :disabled="isView"
                :cache="false"
                :static-options="chargeItemsList"
                @parentCallBack="p=>{chargeItemManagementForm.targetItemId=p}"
              />
            </el-form-item>

            <!--特殊费用标识（已更名：销售特殊费用标识）-->
            <el-form-item v-if="isSpecialExpenseEntryFunction">
              <template slot="label">
                <span>{{ $t('CargoMsg.Cargo_SpecialExpenseIndicator') }}</span>
              </template>
              <el-checkbox v-model="chargeItemManagementForm.specialExpenseMarker" no="specialExpenseMarker" :disabled="isView" />
            </el-form-item>
            <!--商务特殊费用标识-->
            <el-form-item v-if="isSpecialExpenseEntryFunction">
              <template slot="label">
                <span>{{ $t('CargoMsg.Cargo_BusinessSpecialExpenseIndicator') }}</span>
              </template>
              <el-checkbox v-model="chargeItemManagementForm.businessSpecialMarker" no="businessSpecialMarker" :disabled="isView" />
            </el-form-item>
            <!--是否无票费用-->
            <el-form-item v-if="isSpecialExpenseEntryFunction">
              <template slot="label">
                <span>{{ $t('CargoMsg.Cargo_IsNoInvoiceExpense') }}</span>
              </template>
              <el-checkbox
                v-model="chargeItemManagementForm.noInvoiceFee"
                no="noInvoiceFee"
                :disabled="isView"
              />
            </el-form-item>
          </el-form>
        </el-scrollbar>
      </div>
      <div v-if="!isView" slot="footer">
        <el-button no="save" size="size " type="primary" @click="submitPayService">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" size="size " @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 服务项目维护 -->
    <el-dialog
      v-if="showServiceTypeMaintain"
      v-el-drag-dialog
      no="ServiceItems"
      :close-on-click-modal="false"
      :visible.sync="showServiceTypeMaintain"
      :title="$t('CargoMsg.Cargo_ServiceItems')"
      width="500px"
    >
      <el-form ref="serviceTypeForm" :model="serviceTypeForm" label-width="120px" label-position="right">
        <el-form-item :label="$t('CargoMsg.Cargo_ServiceItems')">
          <!--服务项目-->
          <!--          <el-select
            v-model="serviceTypeForm.serviceType"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in setServiceTypeArray"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            />
          </el-select>-->
          <el-cascader
            v-model="serviceTypeForm.serviceType"
            no="serviceType2"
            style="width: 100%;"
            :options="setServiceTypeArray"
            :props="{ checkStrictly: true }"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button no="save2" size="size " type="primary" @click="submitServiceType">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel2" size="size " @click="cancelServiceTypeSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!--合并弹窗-->
    <el-dialog
      v-if="combineChargeItemDialog.visible"
      v-el-drag-dialog
      no="CombineChargeItem"
      :close-on-click-modal="false"
      :visible.sync="combineChargeItemDialog.visible"
      :title="$t('CargoMsg.Cargo_CombineChargeItem')"
      width="1000px"
    >
      <el-form label-width="120px" label-position="right">
        <el-form-item :label="$t('CargoMsg.Cargo_PayService')">
          <span style="font-size: 20px;font-weight:bolder;">{{ combineChargeItemDialog.sourceChargeItemName }}</span>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ConsolidatedChargeItem')">
          <div style="display: flex">
            <el-input
              v-model="combineChargeItemDialog.name"
              no="name2"
              style="width: 286px;"
              :placeholder="$t('Message.PleaseEnterTheNameOfTheCosts')"
            />
            <el-button no="query" type="primary" @click="fetchChargeItem(1)">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          no="1006022-grid"
          config-module="1006022"
          :grid-params.sync="combineChargeItemDialog.gridParams"
          :grid-options="combineChargeItemDialog.gridOptions"
          :column-defs="columnDefs"
          :row-data="combineChargeItemDialog.rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="combineChargeItemDialog.total>0"
          no="1006022-pagination"
          config-module="1006022"
          :total="combineChargeItemDialog.total"
          :page.sync="combineChargeItemDialog.pageNum"
          :limit.sync="combineChargeItemDialog.pageSize"
          @pagination="fetchChargeItem"
        />
      </div>
      <div slot="footer">
        <el-button no="confirm" size="size " type="primary" @click="confirmCombine">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="cancel2" size="size " @click="cancelCombine">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import {
  addPayService,
  batchDelPayService,
  cancelSettingDefault,
  getPayServiceList,
  settingDefault,
  settingServiceType,
  updatePayService,
  combineChargeItem,
  enableOrNot
} from '@/api/payservice'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as chargeApi from '@/api/clearing/charge'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey, getFilterCacheList, syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getLoading } from '@/utils/utilBaseElement'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import ColumnUtils from '@/utils/ColumnUtils'
import $store from '@/store'
import chargeLanguageDialog from '@/components/Cargo/Dmn/chargeLanguage.vue'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'PayService',
  components: { cargoAdvanceSelect, chargeLanguageDialog },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowDoubleClicked: this.rowDoubleClicked
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DefaultTaxRete'),
          field: 'taxRate',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'zhName',
          width: 220
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'enName',
          width: 220
        }, {
          headerName: this.$t('CargoMsg.Cargo_abbreviation'),
          field: 'chargecode',
          width: 220
        }, {
          headerName: this.$t('CargoMsg.Cargo_PlatformCode2'),
          field: 'scaleCode',
          width: 220
        }, {
          headerName: this.$t('CargoMsg.Cargo_ServiceItems'),
          field: 'serviceType',
          cellRenderer: params => {
            return this.getChargeServiceItemByCode(params.value)
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_DefaultOrNot'),
          field: 'defaultChargeItem',
          cellRenderer: params => {
            return this.booleanLabelFunction(params.value)
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_IsCharterFlightCosts'),
          field: 'charterFlight',
          cellRenderer: params => {
            return this.booleanLabelFunction(params.value)
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_IsCharterVesselCosts'),
          field: 'charterVessel',
          cellRenderer: params => {
            return this.booleanLabelFunction(params.value)
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remark',
          width: 220
        }, {
          headerName: this.$t('CargoMsg.Cargo_InterchaneeCode'),
          field: 'interchangeCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnableStatus'),
          field: 'active',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.enableStatusLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('Information.ChargeGroup'),
          field: 'chargeGroupUuid',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeGroup, 'uuid', params.value, $store.getters.language === 'zh' ? 'name' : 'englishName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Index'),
          field: 'itemId',
          width: 100,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_TaxRateRange'),
          field: 'rateRange',
          width: 100,
          hide: true,
          cellRenderer: params => {
            if (params.value) {
              let valueArr = ''
              for (const item of params.value.split(',')) {
                valueArr = valueArr + item + '%,'
              }
              return valueArr.substring(0, valueArr.length - 1)
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreateSource'),
          field: 'source',
          width: 100,
          valueFormatter: (params) => {
            if (params.value) {
              return params.value
            } else {
              return 'cargoWare'
            }
          }
        }],
      searchConditions: {
        name: '',
        itemType: '',
        chargeGroupUuid: '',
        pageNum: 1,
        pageSize: 10,
        total: 4
      },
      chargeServiceItem: {
        '1': this.$t('CargoMsg.Cargo_Booking'),
        '2': this.$t('CargoMsg.Cargo_CustomsDeclaration'),
        '3': this.$t('CargoMsg.Cargo_Storage'),
        '4': this.$t('CargoMsg.Cargo_Transportation'),
        '5': this.$t('CargoMsg.Cargo_Other'),
        '6': this.$t('CargoMsg.Cargo_Preplan'),
        '61': this.$t('CargoMsg.Cargo_Preplan'),
        // '62': this.$t('CargoMsg.Cargo_SeaManagerSendPreplan'),
        // '63': this.$t('CargoMsg.Cargo_SeaManagerUpdatePreplan'),
        // '64': this.$t('CargoMsg.Cargo_SeaManagerDeletePreplan'),
        '65': this.$t('CargoMsg.Cargo_WseSendMPreplanQd'),
        '66': this.$t('CargoMsg.Cargo_WseSendPreplanQd'),
        '67': this.$t('CargoMsg.Cargo_WseSendUpdatePreplanQd'),
        '68': this.$t('CargoMsg.Cargo_WseDeletePreplanQd'),
        '69': this.$t('CargoMsg.Cargo_WseSendPreplanSh'),
        '610': this.$t('CargoMsg.Cargo_WseSendUpdatePreplanSh'),
        '611': this.$t('CargoMsg.Cargo_WseDeletePreplanSh'),
        '7': 'VGM',
        '71': 'VGM',
        // '72': this.$t('CargoMsg.Cargo_SeaManagerSendingVGM'),
        '73': this.$t('CargoMsg.Cargo_WseSendingVGM')
      },
      itemTypeArray: [
        {
          'desc': this.$t('CargoMsg.Cargo_All'),
          'code': ''
        },
        {
          'desc': this.$t('CargoMsg.Cargo_OceanExport'),
          'code': 'isForSeaExp'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_OceanImport'),
          'code': 'isForSeaImp'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_AirExport'),
          'code': 'isForAirExp'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_AirImport'),
          'code': 'isForAirImp'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_RailwayBusiness'),
          'code': 'isForRwyExp'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_FbaSea'),
          'code': 'isForFbaSea'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_FbaAir'),
          'code': 'isForFbaAir'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_FbaRailway'),
          'code': 'isForFbaRailway'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_Controlled'),
          'code': 'isControlled'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_NeedInvoice'),
          'code': 'isNeedInvoice'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_IntegratedJob'),
          'code': 'isForIntegratedJob'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_CommissionItems'),
          'code': 'isCommission'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_AdvancePaymentItem'),
          'code': 'isAdvance'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_Surcharge'),
          'code': 'isSurcharge'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_LocalCharge'),
          'code': 'isLocalCharge'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_DesCharge'),
          'code': 'isDesCharge'
        }
      ],
      serviceTypeArray: [
        {
          label: this.$t('CargoMsg.Cargo_PleaseSelect'),
          value: 0
        },
        {
          label: this.$t('CargoMsg.Cargo_Booking'),
          value: 1
        },
        {
          label: this.$t('CargoMsg.Cargo_CustomsDeclaration'),
          value: 2
        },
        {
          label: this.$t('CargoMsg.Cargo_Storage'),
          value: 3
        },
        {
          label: this.$t('CargoMsg.Cargo_Transportation'),
          value: 4
        },
        {
          label: this.$t('CargoMsg.Cargo_Other'),
          value: 5
        },
        {
          label: this.$t('CargoMsg.Cargo_Preplan'), // 预配
          value: 6,
          children: [{
            value: 61,
            label: this.$t('CargoMsg.Cargo_Preplan')
          },
          // {
          //   value: 62,
          //   label: this.$t('CargoMsg.Cargo_SeaManagerSendPreplan')
          // }, {
          //   value: 63,
          //   label: this.$t('CargoMsg.Cargo_SeaManagerUpdatePreplan')
          // }, {
          //   value: 64,
          //   label: this.$t('CargoMsg.Cargo_SeaManagerDeletePreplan')
          // },
          {
            value: 65,
            label: this.$t('CargoMsg.Cargo_WseSendMPreplanQd')
          }, {
            value: 66,
            label: this.$t('CargoMsg.Cargo_WseSendPreplanQd')
          }, {
            value: 67,
            label: this.$t('CargoMsg.Cargo_WseSendUpdatePreplanQd')
          }, {
            value: 68,
            label: this.$t('CargoMsg.Cargo_WseDeletePreplanQd')
          }, {
            value: 69,
            label: this.$t('CargoMsg.Cargo_WseSendPreplanSh')
          }, {
            value: 610,
            label: this.$t('CargoMsg.Cargo_WseSendUpdatePreplanSh')
          }, {
            value: 611,
            label: this.$t('CargoMsg.Cargo_WseDeletePreplanSh')
          }]
        },
        {
          label: 'VGM',
          value: 7,
          children: [{
            value: 71,
            label: 'VGM'
          },
          // {
          //   value: 72,
          //   label: this.$t('CargoMsg.Cargo_SeaManagerSendingVGM')
          // },
          {
            value: 73,
            label: this.$t('CargoMsg.Cargo_WseSendingVGM')
          }]
        },
        {
          label: this.$t('SeaExport.Anti_terrorismShipping'),
          value: 7,
          children: [
            {
              value: 74,
              label: this.$t('CargoMsg.Cargo_Ams')
            },
            {
              value: 75,
              label: this.$t('CargoMsg.Cargo_Aci')
            },
            {
              value: 76,
              label: this.$t('CargoMsg.Cargo_Afr')
            },
            {
              value: 77,
              label: this.$t('CargoMsg.Cargo_EMainfest')
            },
            {
              value: 78,
              label: this.$t('CargoMsg.Cargo_Ens')
            }
          ]
        }
      ],
      defaultObjArray: [
        {
          'desc': this.$t('CargoMsg.Cargo_PleaseSelect'),
          'code': 'QXZ'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_AuthorizedClient'),
          'code': 'WTDW'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_BookingAgent'),
          'code': 'DCDW'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_CarrierAgent'),
          'code': 'CAG'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_Carrier'),
          'code': 'CYR'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_Motorcade'),
          'code': 'CD'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_Warehouse'),
          'code': 'CK'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_CustomsBroker'),
          'code': 'BGH'
        },
        {
          'desc': this.$t('CargoMsg.Cargo_DestinationAgent1'),
          'code': 'HYDL'
        },
        {
          'desc': this.$t('RailwayExport.forwardingAgent'),
          'code': 'FYDL'
        },
        {
          'desc': this.$t('Message.TerminalCompany'),
          'code': 'MTGS'
        },
        {
          'desc': this.$t('Message.Shipper'),
          'code': 'FHR'
        },
        {
          'desc': this.$t('Message.Consignee'),
          'code': 'SHR'
        },
        {
          'desc': this.$t('Message.Notify'),
          'code': 'TZR'
        }
      ],
      intervalTypeArray: [ // 区间类型
        {
          'desc': this.$t('CargoMsg.Cargo_GrandTotal'),
          'code': 0
        }
      ],
      showChargeItemMaintain: false,
      chargeItemManagementMaintainTitle: this.$t('CargoMsg.Cargo_ChargeItemMaintenance'),
      chargeItemManagementForm: {
        itemId: '',
        targetItemId: '',
        serialNumber: '',
        chargecode: '',
        scaleCode: '',
        zhName: '',
        enName: '',
        serviceType: 0,
        seaExport: false,
        seaImport: false,
        airExport: false,
        airImport: false,
        integratedJob: false,
        fbaSea: false,
        fbaAir: false,
        fbaRailway: false,
        controlled: false,
        needInvoice: true,
        railwayExport: false,
        commission: false,
        advance: false,
        surcharge: false,
        localCharge: false,
        desCharge: false,
        defaultChargeItem: false,
        charterFlight: false,
        charterVessel: false,
        forothers: false,
        zeroTaxRate: false,
        defaultArCode: '',
        defaultarcurrency: '',
        defaultarprice: '',
        defaultApCode: '',
        defaultapcurrency: '',
        defaultapprice: '',
        remark: '',
        version: '',
        measure: '',
        branchId: '',
        defaultArAccountId: 0,
        defaultApAccountId: 0,
        useDefaultArCode: false,
        useDefaultApCode: false,
        taxRate: 0.00,
        defaultArMode: false, // 默认应收模式
        suitArRate: false, // 应收默认费率-适用
        defaultArRate: 0.00, // 应收默认费率
        suitSecondArRate: false, // 应收第二费率-适用
        secondArRate: 0.00, // 应收第二费率
        suitArAmountInterval: false, // 应收费额区间-适用
        arAmountIntervalMin: 0.00, // 应收费额区间-最小值
        arAmountIntervalMax: 0.00, // 应收费额区间-最大值
        arIntervalType: 0, // 应收区间类型
        defaultApMode: false, // 默认应付模式
        suitApRate: false, // 应付默认费率-适用
        defaultApRate: 0.00, // 应付默认费率
        suitSecondApRate: false, // 应付第二费率-适用
        secondApRate: 0.00, // 应付第二费率
        suitApAmountInterval: false, // 应付费额区间-适用
        apAmountIntervalMin: 0.00, // 应付费额区间-最小值
        apAmountIntervalMax: 0.00, // 应付费额区间-最大值
        apIntervalType: 0, // 应付区间类型
        active: true, // 默认启用状态
        chargeGroupUuid: '',
        uncheckArApMate: false,
        specialExpenseMarker: false,
        businessSpecialMarker: false,
        noInvoiceFee: false,
        chargeLanguageList: [],
        chargeLanguageIds: [],
        rateRange: '',
        rateRangeArr: [],
        autoGenerateChargeId: 0,
        autoGenerateChargeTaxRate: 0.00
      },
      showServiceTypeMaintain: false,
      serviceTypeForm: {
        serviceType: ''
      },
      payServiceTypeArray: [],
      measureArray: [],
      setServiceTypeArray: [
        {
          label: this.$t('CargoMsg.Cargo_Booking'),
          value: 1
        },
        {
          label: this.$t('CargoMsg.Cargo_CustomsDeclaration'),
          value: 2
        },
        {
          label: this.$t('CargoMsg.Cargo_Storage'),
          value: 3
        },
        {
          label: this.$t('CargoMsg.Cargo_Transportation'),
          value: 4
        },
        {
          label: this.$t('CargoMsg.Cargo_Other'),
          value: 5
        },
        {
          label: this.$t('CargoMsg.Cargo_Preplan'), // 预配
          value: 6,
          children: [{
            value: 61,
            label: this.$t('CargoMsg.Cargo_Preplan')
          },
          // {
          //   value: 62,
          //   label: this.$t('CargoMsg.Cargo_SeaManagerSendPreplan')
          // }, {
          //   value: 63,
          //   label: this.$t('CargoMsg.Cargo_SeaManagerUpdatePreplan')
          // }, {
          //   value: 64,
          //   label: this.$t('CargoMsg.Cargo_SeaManagerDeletePreplan')
          // },
          {
            value: 65,
            label: this.$t('CargoMsg.Cargo_WseSendMPreplanQd')
          }, {
            value: 66,
            label: this.$t('CargoMsg.Cargo_WseSendPreplanQd')
          }, {
            value: 67,
            label: this.$t('CargoMsg.Cargo_WseSendUpdatePreplanQd')
          }, {
            value: 68,
            label: this.$t('CargoMsg.Cargo_WseDeletePreplanQd')
          }, {
            value: 69,
            label: this.$t('CargoMsg.Cargo_WseSendPreplanSh')
          }, {
            value: 610,
            label: this.$t('CargoMsg.Cargo_WseSendUpdatePreplanSh')
          }, {
            value: 611,
            label: this.$t('CargoMsg.Cargo_WseDeletePreplanSh')
          }]
        },
        {
          label: 'VGM',
          value: 7,
          children: [{
            value: 71,
            label: 'VGM'
          },
          // {
          //   value: 72,
          //   label: this.$t('CargoMsg.Cargo_SeaManagerSendingVGM')
          // },
          {
            value: 73,
            label: this.$t('CargoMsg.Cargo_WseSendingVGM')
          }]
        }
      ],
      fullscreenLoading: null,
      isView: false,
      combineChargeItemDialog: {
        visible: false,
        sourceChargeItemName: '',
        sourceChargeItemUuid: '',
        name: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          onRowClicked: this.onCombineGridRowClickedEvent
        }
      },
      chargeItemsList: [],
      isMergeChargeItemSalesView: false,
      isSpecialExpenseEntryFunction: false
    }
  },
  computed: {
    url() {
      return URL
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  mounted() {
    // 初始化费率列表
    this.fetchPayServiceList()
    // 初始化
    this.initMeasure()
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isMergeChargeItemSalesView = Number(cache.config.get('MergeChargeItemSalesView')) === 1
    this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1 // 专项费用录入功能配置
    this.initChargeItem()
  },
  methods: {
    initChargeItem() {
      if (this.isMergeChargeItemSalesView) {
        // 获取费用项列表
        const chargeItems = getCacheListByKey(TYPE_NAMES.basic_data_ChargeItem)
        this.chargeItemsList = this.chargeItemManagementForm.uuid ? chargeItems.filter(chargeItem => Number(chargeItem.itemId) !== Number(this.chargeItemManagementForm.itemId)) : chargeItems
      }
    },
    // 获取费率列表
    fetchPayServiceList() {
      const self = this
      self.fullscreenLoading = getLoading()
      const params = { ...this.searchConditions }
      getPayServiceList(params).then(res => {
        self.rowData = res.data.list
        for (const item of self.rowData) {
          if (item.rateRange) {
            item.rateRangeArr = item.rateRange.split(',')
          }
        }
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
        self.fullscreenLoading.close()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    initMeasure() {
      const l = getCacheListByKey(basicCacheKeys.basic_data_ChargeUnit)
      this.measureArray = l
    },
    popPayServiceAddFormDialog() {
      this.chargeItemManagementMaintainTitle = this.$t('CargoMsg.Cargo_ChargeItemMaintenance'),
      this.showChargeItemMaintain = true
      this.isView = false
      let measure = ''
      const l = getCacheListByKey(basicCacheKeys.basic_data_ChargeUnit)
      this.measureArray = l
      for (const i of this.measureArray) {
        if (i.ifDefault) {
          measure = i.code
        }
      }
      if (measure === '' && this.measureArray.length > 0) {
        measure = this.measureArray[0].code
      }
      this.chargeItemManagementForm = {
        serialNumber: 0,
        measure: measure,
        serviceType: 0,
        seaExport: false,
        seaImport: false,
        airExport: false,
        airImport: false,
        railwayExport: false,
        controlled: false,
        needInvoice: true,
        commission: false,
        advance: false,
        surcharge: false,
        localCharge: false,
        desCharge: false,
        defaultChargeItem: false,
        charterFlight: false,
        charterVessel: false,
        forothers: false,
        zeroTaxRate: false,
        defaultApCode: 'QXZ',
        defaultArCode: 'QXZ',
        defaultArMode: false, // 默认应收模式
        suitArRate: false, // 应收默认费率-适用
        defaultArRate: 0.00, // 应收默认费率
        suitSecondArRate: false, // 应收第二费率-适用
        secondArRate: 0.00, // 应收第二费率
        suitArAmountInterval: false, // 应收费额区间-适用
        arAmountIntervalMin: 0.00, // 应收费额区间-最小值
        arAmountIntervalMax: 0.00, // 应收费额区间-最大值
        arIntervalType: 0, // 应收区间类型
        defaultApMode: false, // 默认应付模式
        suitApRate: false, // 应付默认费率-适用
        defaultApRate: 0.00, // 应付默认费率
        suitSecondApRate: false, // 应付第二费率-适用
        secondApRate: 0.00, // 应付第二费率
        suitApAmountInterval: false, // 应付费额区间-适用
        apAmountIntervalMin: 0.00, // 应付费额区间-最小值
        apAmountIntervalMax: 0.00, // 应付费额区间-最大值
        apIntervalType: 0, // 应付区间类型
        active: true, // 默认启用状态
        noInvoiceFee: false, // 是否无票费用
        defaultWhtRate: 0.00 // 默认WHT税率
      }
      this.chargeItemManagementForm.branchId = this.$store.getters.currentOfficeId
    },
    popPayServiceEditFormDialog() {
      const self = this
      this.chargeItemManagementMaintainTitle = this.$t('CargoMsg.Cargo_ChargeItemMaintenance'),
      this.isView = false
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          this.$message.error(this.$t('common.tips.hasOneAtleast'))
        } else {
          self.chargeItemManagementForm = { ...getGridSelected(this.gridOptions)[0] }
          if (self.chargeItemManagementForm.noInvoiceFee === undefined) {
            self.$set(self.chargeItemManagementForm, 'noInvoiceFee', false)
          }
          self.chargeItemManagementForm.defaultArRate = self.chargeItemManagementForm.defaultArRate ? (self.chargeItemManagementForm.defaultArRate * 100) : self.chargeItemManagementForm.defaultArRate
          self.chargeItemManagementForm.secondArRate = self.chargeItemManagementForm.secondArRate ? (self.chargeItemManagementForm.secondArRate * 100) : self.chargeItemManagementForm.secondArRate
          self.chargeItemManagementForm.defaultApRate = self.chargeItemManagementForm.defaultApRate ? (self.chargeItemManagementForm.defaultApRate * 100) : self.chargeItemManagementForm.defaultApRate
          self.chargeItemManagementForm.secondApRate = self.chargeItemManagementForm.secondApRate ? (self.chargeItemManagementForm.secondApRate * 100) : self.chargeItemManagementForm.secondApRate
          const serviceType = self.chargeItemManagementForm.serviceType
          if (serviceType.toString().length > 1) {
            self.chargeItemManagementForm.serviceType = [Number(serviceType.toString().substr(0, 1)), serviceType]
          }
          self.chargeItemManagementForm.isEdit = true
          self.showChargeItemMaintain = true
        }
        this.initChargeItem()
      })
    },
    toBatchDel() {
      const self = this
      const payServiceArray = this.getPayServiceSelected()
      if (payServiceArray) {
        this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          batchDelPayService(payServiceArray).then(res => {
            self.fetchPayServiceList()
            this.$message({
              type: 'success',
              message: this.$t('common.tips.deleteSuccess')
            })
          })
        }).catch(err => {
          console.log(err)
          this.$message({
            type: 'info',
            message: this.$t('common.tips.cancelDelete')
          })
        })
      }
    },
    getPayServiceSelected() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return null
      }
      return selectedRows
    },
    // 批量设置默认
    batchSettingDefault() {
      const payServiceSettingDefaultArray = this.getPayServiceSelected()
      if (payServiceSettingDefaultArray) {
        settingDefault(payServiceSettingDefaultArray).then(res => {
          this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
        }).then(() => {
          this.fetchPayServiceList()
        })
      }
    },
    // 批量取消默认
    batchCancelDefault() {
      const payServiceCancelDefaultArray = this.getPayServiceSelected()
      if (payServiceCancelDefaultArray) {
        cancelSettingDefault(payServiceCancelDefaultArray).then(res => {
          this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
        }).then(() => {
          this.fetchPayServiceList()
        })
      }
    },
    // 设置服务类型弹窗
    popSettingServiceTypeDialog() {
      this.payServiceTypeArray = this.getPayServiceSelected()
      if (this.payServiceTypeArray) {
        this.serviceTypeForm.serviceType = ''
        this.showServiceTypeMaintain = true
      }
    },
    // 获取服务类型方法
    getChargeServiceItemByCode(code) {
      return this.chargeServiceItem[code] ? this.chargeServiceItem[code] : ''
    },
    booleanLabelFunction(value) {
      return value === false ? this.$t('CargoMsg.Cargo_No') : this.$t('CargoMsg.Cargo_Yes')
    },
    submitPayService() {
      if ((!this.chargeItemManagementForm.autoGenerateChargeId && this.chargeItemManagementForm.autoGenerateChargeTaxRate) ||
        (this.chargeItemManagementForm.autoGenerateChargeId && !this.chargeItemManagementForm.autoGenerateChargeTaxRate)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TaxNameRateConsistency'))
        return
      }
      if (this.chargeItemManagementForm.autoGenerateChargeTaxRate && this.chargeItemManagementForm.taxRate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AutoGenerateOrDefaultTaxExclusive'))
        return
      }
      if (this.chargeItemManagementForm.uuid) {
        const row = this.rowData.find(row => row.uuid === this.chargeItemManagementForm.uuid)
        if (row.zhName !== this.chargeItemManagementForm.zhName) {
          chargeApi.isRemoveChargeItem(this.chargeItemManagementForm.itemId).then(resp => {
            this.editChargeItemResultHandler(resp)
          })
        } else {
          this.saveChargeItem()
        }
      } else {
        this.saveChargeItem()
      }
    },
    editChargeItemResultHandler(resp) {
      const flag = resp.data
      if (flag) {
        this.$message.warning('[' + this.chargeItemManagementForm.zhName + ']' + this.$t('Message.CannotBeModified'))
      } else {
        this.saveChargeItem()
      }
    },
    async saveChargeItem() {
      if (!this.chargeItemManagementForm.zhName) {
        this.$message.warning(this.$t('Message.ChineseNameCannotBeBlank'))
        return
      }
      for (const chargeItem of this.rowData) {
        if (chargeItem.uuid === this.chargeItemManagementForm.uuid) continue
        if (this.chargeItemManagementForm.zhName === chargeItem.zhName || (this.chargeItemManagementForm.enName && chargeItem.enName && this.chargeItemManagementForm.enName === chargeItem.enName)) {
          this.$message.warning(this.$t('Message.NameCannotBeRepeated'))
          return
        }
      }
      if (this.chargeItemManagementForm.scaleCode) {
        const charge = await ChargeItem.getChargeItemByScaleCode(this.chargeItemManagementForm.scaleCode)
        if (charge && charge.itemId !== this.chargeItemManagementForm.itemId) {
          this.$message.warning(this.$t('Message.PlatformCodeAlreadyExists'))
          return
        }
      }
      const serviceTypes = this.chargeItemManagementForm.serviceType
      if (serviceTypes && serviceTypes.length > 0) {
        this.chargeItemManagementForm.serviceType = serviceTypes[serviceTypes.length - 1]
      }
      // 目前阶段，当前租户仅支持一个组费用合并展示。
      if (this.isMergeChargeItemSalesView && this.chargeItemManagementForm.targetItemId && Number(this.chargeItemManagementForm.targetItemId) > 0) {
        const chargeItems = getCacheListByKey(TYPE_NAMES.basic_data_ChargeItem)
        for (const chargeItem of chargeItems) {
          if (chargeItem.targetItemId && Number(chargeItem.targetItemId) > 0 && chargeItem.itemId !== this.chargeItemManagementForm.itemId) {
            this.$message.warning(this.$t('Information.MergeAndDisplayTips'))
            return
          }
        }
      }
      if (!this.chargeItemManagementForm.isEdit) {
        this.toAddPayService()
      } else {
        this.toEditPayService()
      }
    },
    // 编辑收费项目
    toEditPayService() {
      const self = this
      if (!self.chargeItemManagementForm.serviceType) {
        this.chargeItemManagementForm.serviceType = 0
      }
      self.fullscreenLoading = getLoading()
      updatePayService(this.chargeItemManagementForm).then(res => {
        this.showChargeItemMaintain = false
        this.chargeItemManagementForm = {
          serialNumber: 0,
          measure: '',
          serviceType: 0,
          seaExport: false,
          seaImport: false,
          airExport: false,
          airImport: false,
          railwayExport: false,
          controlled: false,
          needInvoice: true,
          commission: false,
          advance: false,
          surcharge: false,
          localCharge: false,
          desCharge: false,
          defaultChargeItem: false,
          charterFlight: false,
          charterVessel: false,
          forothers: false,
          zeroTaxRate: false,
          defaultWhtRate: 0
        }
        self.fullscreenLoading.close()
        this.$message({ message: this.$t('common.tips.editSuccess'), type: 'success' })
        // 新增费用项是刷新费用项语言配置缓存
        if ((this.chargeItemManagementForm.chargeLanguageList && this.chargeItemManagementForm.chargeLanguageList.length > 0) || (this.chargeItemManagementForm.chargeLanguageIds && this.chargeItemManagementForm.chargeLanguageIds.length > 0)) {
          syncSpecificBasicData(basicCacheKeys.basic_data_ChargeItemLanguage)
        }
      }).then(() => {
        this.fullscreenLoading.close()
        this.fetchPayServiceList()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    // 新增收费项目
    toAddPayService() {
      if (!this.chargeItemManagementForm.serviceType) {
        this.chargeItemManagementForm.serviceType = 0
      }
      addPayService(this.chargeItemManagementForm).then(res => {
        this.showChargeItemMaintain = false
        this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
      }).then(() => {
        // 新增费用项是刷新费用项语言配置缓存
        if ((this.chargeItemManagementForm.chargeLanguageList && this.chargeItemManagementForm.chargeLanguageList.length > 0) || (this.chargeItemManagementForm.chargeLanguageIds && this.chargeItemManagementForm.chargeLanguageIds.length > 0)) {
          syncSpecificBasicData(basicCacheKeys.basic_data_ChargeItemLanguage)
        }
        this.fetchPayServiceList()
      })
    },
    // 取消保存或者编辑
    cancelSaveOrEdit() {
      this.showChargeItemMaintain = false
      this.chargeItemManagementForm = {}
    },
    // 提交服务类型
    submitServiceType() {
      if (!this.serviceTypeForm.serviceType) {
        this.$message.error(this.$t('Message.PleaseSelectAServiceItem'))
        return
      }
      settingServiceType(this.serviceTypeForm.serviceType, this.payServiceTypeArray).then(res => {
        this.showServiceTypeMaintain = false
        this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
      }).then(() => {
        this.fetchPayServiceList()
      })
    },
    // 取消服务类型保存或编辑
    cancelServiceTypeSaveOrEdit() {
      this.showServiceTypeMaintain = false
      this.serviceTypeForm = {
        serviceType: ''
      }
      this.payServiceTypeArray = []
    },
    selectCargoItem(item) {
      this.chargeItemManagementForm[item.key] = item.value
    },
    serialNumberCharge() {
      this.chargeItemManagementForm.serialNumber = this.chargeItemManagementForm.serialNumber ? Math.round(this.chargeItemManagementForm.serialNumber) : '0'
    },
    // 行双击触发事件
    rowDoubleClicked: function(event) {
      this.chargeItemManagementMaintainTitle = this.$t('CargoMsg.Cargo_ChargeItemView')
      this.chargeItemManagementForm = { ...event.data }
      if (this.chargeItemManagementForm.noInvoiceFee === undefined) {
        this.$set(this.chargeItemManagementForm, 'noInvoiceFee', false)
      }
      this.chargeItemManagementForm.defaultArRate = this.chargeItemManagementForm.defaultArRate ? (this.chargeItemManagementForm.defaultArRate * 100) : this.chargeItemManagementForm.defaultArRate
      this.chargeItemManagementForm.secondArRate = this.chargeItemManagementForm.secondArRate ? (this.chargeItemManagementForm.secondArRate * 100) : this.chargeItemManagementForm.secondArRate
      this.chargeItemManagementForm.defaultApRate = this.chargeItemManagementForm.defaultApRate ? (this.chargeItemManagementForm.defaultApRate * 100) : this.chargeItemManagementForm.defaultApRate
      this.chargeItemManagementForm.secondApRate = this.chargeItemManagementForm.secondApRate ? (this.chargeItemManagementForm.secondApRate * 100) : this.chargeItemManagementForm.secondApRate
      this.showChargeItemMaintain = true
      this.isView = true
    },
    defaultArCodeChange() {
      if (this.chargeItemManagementForm.defaultArCode === 'QXZ') {
        this.chargeItemManagementForm.useDefaultArCode = false
      }
    },
    defaultApCodeChange() {
      if (this.chargeItemManagementForm.defaultApCode === 'QXZ') {
        this.chargeItemManagementForm.useDefaultApCode = false
      }
    },
    // 未勾选则置0
    formatChargeRate() {
      if (!this.chargeItemManagementForm.suitArRate) this.chargeItemManagementForm.defaultArRate = 0
      if (!this.chargeItemManagementForm.suitSecondArRate) this.chargeItemManagementForm.secondArRate = 0
      if (!this.chargeItemManagementForm.suitApRate) this.chargeItemManagementForm.defaultApRate = 0
      if (!this.chargeItemManagementForm.suitSecondApRate) this.chargeItemManagementForm.secondApRate = 0
      if (!this.chargeItemManagementForm.suitArAmountInterval) {
        this.chargeItemManagementForm.arAmountIntervalMin = 0
        this.chargeItemManagementForm.arAmountIntervalMax = 0
      }
      if (!this.chargeItemManagementForm.suitApAmountInterval) {
        this.chargeItemManagementForm.apAmountIntervalMin = 0
        this.chargeItemManagementForm.apAmountIntervalMax = 0
      }
    },
    combineChargeItem() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length <= 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.combineChargeItemDialog.name = ''
      this.combineChargeItemDialog.pageNum = 1
      this.combineChargeItemDialog.rowData = []
      this.combineChargeItemDialog.sourceChargeItemName = this.$store.getters.language === 'zh' ? selectedRows[0].zhName : selectedRows[0].enName
      this.combineChargeItemDialog.sourceChargeItemUuid = selectedRows[0].uuid
      this.combineChargeItemDialog.visible = true
    },
    confirmCombine() {
      const selectedRows = this.combineChargeItemDialog.gridOptions.api.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      const row = selectedRows[0]
      const text = this.$store.getters.language === 'zh' ? row.zhName : row.enName
      if (row.uuid === this.combineChargeItemDialog.sourceChargeItemUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CombineChargeItemTipsThree'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_CombineChargeItemTips', [this.combineChargeItemDialog.sourceChargeItemName, text]), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        combineChargeItem({ 'targetUuid': this.combineChargeItemDialog.sourceChargeItemUuid, 'sourceUuid': row.uuid }).then(res => {
          let message = "<h6 style='margin: 0; text-align: center; font-size: 14px; color: #000;'>"
          message = message + this.$t('CargoMsg.Cargo_CombineChargeItemTipsOne') + "</h6><p style='text-align: center; margin: 5px auto 20px;'>"
          message = message + this.$t('CargoMsg.Cargo_CombineChargeItemTipsTwo') + '</p>'
          this.$alert(message, this.$t('Message.Prompt'), {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('common.tips.confirm')
          })
          this.cancelCombine()
        })
      }).catch(() => {
      })
    },
    cancelCombine() {
      this.combineChargeItemDialog.name = ''
      this.combineChargeItemDialog.pageNum = 1
      this.combineChargeItemDialog.rowData = []
      this.combineChargeItemDialog.sourceChargeItemName = ''
      this.combineChargeItemDialog.sourceChargeItemUuid = ''
      this.combineChargeItemDialog.visible = false
    },
    onCombineGridRowClickedEvent: function(event) {
      this.combineChargeItemDialog.selectRow = event.data || null
    },
    fetchChargeItem(pageNum = 0) {
      this.fullscreenLoading = getLoading()
      const params = { name: this.combineChargeItemDialog.name, pageNum: pageNum > 0 ? pageNum : this.combineChargeItemDialog.pageNum, pageSize: this.combineChargeItemDialog.pageSize }
      getPayServiceList(params).then(res => {
        this.combineChargeItemDialog.rowData = res.data.list
        this.combineChargeItemDialog.pageNum = res.data.pageNum
        this.combineChargeItemDialog.pageSize = res.data.pageSize
        this.combineChargeItemDialog.total = Number(res.data.total)
      }).catch(() => {
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 启用/禁用收费项目
    enableOrNot(active = true) {
      const selectedRows = getGridSelected(this.gridOptions)
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      const keys = []
      for (const item of selectedRows) {
        if (active) { // 启用
          if (!item.active) {
            keys.push(item.uuid)
          }
        } else { // 禁用
          if (item.active) {
            keys.push(item.uuid)
          }
        }
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataCanBeModified'))
        return
      }
      this.fullscreenLoading = getLoading()
      enableOrNot({ 'keys': keys, 'active': active }).then(res => {
        if (active) {
          this.$message.success(this.$t('CargoMsg.Cargo_DataEnableSuccess'))
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_DataDisEnableSuccess'))
        }
        syncSpecificBasicData(basicCacheKeys.basic_data_ChargeItem).then(() => {
        }).catch(() => {
        })
        this.fetchPayServiceList()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    // 修改零税率
    changeZeroTaxRate() {
      if (this.chargeItemManagementForm.zeroTaxRate) {
        this.chargeItemManagementForm.taxRate = 0
      }
    },
    toFixedIfNumber(value, digits) {
      if (typeof value === 'number') {
        return value.toFixed(digits)
      }
      return value
    },
    onDefaultWhtRateInput(value) {
      // 非数字
      if (/[^0-9.]/.test(value)) {
        return
      }
      // indexOf、lastIndexOf的返回值分三种情况：
      // 1、没有“.”，都是-1（相等）
      // 2、有一个“.”，都是同一个值（相等）
      // 3、有两个及以上的“.”，值不一样（不相等）
      if (value.indexOf('.') !== value.lastIndexOf('.')) {
        return
      }
      this.chargeItemManagementForm.defaultWhtRate = value
    },
    onDefaultWhtRateChange() {
      this.chargeItemManagementForm.defaultWhtRate = Number(this.chargeItemManagementForm.defaultWhtRate) || 0
    },
    // 接收子组件传来的值走大保存
    chargeLanguageValues(values, deluuids) {
      this.chargeItemManagementForm.chargeLanguageList = values
      this.chargeItemManagementForm.chargeLanguageIds = deluuids
    },
    changeServiceType() {
      const serviceTypes = this.chargeItemManagementForm.serviceType
      if (serviceTypes && serviceTypes.length > 0) {
        const serviceType = serviceTypes[serviceTypes.length - 1]
        if (serviceType === 6) {
          this.chargeItemManagementForm.serviceType = [6, 61]
        }
        if (serviceType === 7) {
          this.chargeItemManagementForm.serviceType = [7, 71]
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pay-management {
  .charge-item-maintain-dialog ::v-deep {
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
}
</style>
